import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as saveAs from 'file-saver';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ExportCriteria } from '../../src/typings/models';
import { IExportSensorDataService } from '../../src/typings/services';
import { $http } from '../ajs-upgraded-providers';

@Injectable({
    providedIn: 'root'
})
export class ExportSensorDataService implements IExportSensorDataService {
    public static $name: string = 'exportSensorDataService';

    constructor(
        private http: HttpClient,
        @Inject($http) private angularHttp: angular.IHttpService,
    ) {
    }

    public exportSensorData(exportCriteria: ExportCriteria): Observable<void> {
        return this.http.post('api/sensorDownload/getSensorDataDownload', {
                    end: exportCriteria.endDate,
                    exportType: exportCriteria.exportType,
                    sensorIds: exportCriteria.sensorIds,
                    start: exportCriteria.startDate,
                },
                {
                    headers: {
                        'X-XSRF-Token': this.angularHttp.defaults.headers.common['X-XSRF-Token']
                    },
                    observe: 'response',
                    responseType: 'blob',
                    withCredentials: true,
            }).pipe(map((res: HttpResponse<Blob>) => {
                const file = new Blob([res.body], { type: res.headers.get('file-content-type') || 'text/plain' });

                saveAs(file, res.headers.get('file-name'));
            })).pipe(take(1));
    }
}
